import React, { useCallback, useEffect, useState } from "react";
import FlusterCard from "../components/FlusterCard";
import FlusterButton from "../components/FlusterButton";
import FlusterTimeButton from "../components/FlusterTimerButton";
import _ from "lodash";
import Socket from "socket";
import FlusterVoteCard from "../components/FlusterVoteCard";
import { useDispatch } from "react-redux";
import { set_ready_to_vote } from "redux/game/action";
import FlusterVote from "../components/FlusterVote";
import { motion } from "framer-motion/dist/framer-motion";
import { divVariants, fadeVariants } from "shared/components/animations";
const FLUSQuestion = ({
  roomId,
  timer,
  currentPlayerId,

  isAskerPlayer,
  isAnswererPlayer,
  askerAskedQuestion,
  currentPlayerCard,
  askerReadytoVote,
  screens,
  currentPlayerVote
}) => {
  const asker_player_info = _.get(
    screens,
    "asker.4_question.info_2",
    "Read aloud"
  );
  const asker_player_btn_info = _.get(
    screens,
    "asker.4_question.button_1",
    "Ready to vote!"
  );
  const asker_player_vote_btn_info = _.get(
    screens,
    "asker.4_question.button_2",
    "VOTE"
  );
  const asker_player_vote_info = _.get(
    screens,
    "asker.4_question.info_4",

    "What do you think of the answer?"
  );
  const asker_player_vote_info2 = _.get(
    screens,
    "asker.4_question.info_5",
    "VOTE NOW!"
  );
  const answerer_player_info = _.get(
    screens,
    "answerer.4_question.info_7",
    "Read aloud"
  );

  const answerer_player_btn_info = _.get(
    screens,
    "answerer.4_question.button",
    "Read aloud"
  );

  const other_player_btn_info = _.get(
    screens,
    "other_players.4_question.button",

    "VOTE"
  );
  const other_player_info = _.get(
    screens,
    "other_players.4_question.info_2",

    "What do you think of the answer?"
  );
  const other_player_info2 = _.get(
    screens,
    "other_players.4_question.info_3",
    "VOTE NOW!"
  );

  const dispatch = useDispatch();
  const [votePoint, setVotePoint] = useState(1);
  const [selectedSpecialCard, setSelectedSpecialCard] = useState({});
  const [countDown, setCountDown] = useState(timer);
  const GetSpecialCard =
    currentPlayerCard?.cards.filter((item) => item.special !== "None") || [];

  const handleVotePoint = (value) => {
    setVotePoint(value);
  };
  const voteButtonClickAction = () => {
    if (!isAnswererPlayer) {
      const data = {
        action: "vote-flus",
        roomId,
        playerId: currentPlayerId,
        points: votePoint
      };
      Socket.sendMessage(data);
    }
  };
  const handleVoteButtonClick = useCallback(
    _.debounce(() => voteButtonClickAction(), 1000, {
      leading: true,
      trailing: false
    }),
    [votePoint]
  );
  const isAskerReadyVote = () => {
    dispatch(set_ready_to_vote(true));
  };

  const handleSpecialCardClick = (value) => {
    setSelectedSpecialCard(value);
  };
  const specialCardButtonAction = () => {
    if (isAnswererPlayer) {
      const data = {
        action: "play-card-flus",
        roomId,
        playerId: currentPlayerId,
        cardId: selectedSpecialCard.id
      };
      Socket.sendMessage(data);
    }
  };
  const handleSpecialCardButton = useCallback(
    _.debounce(() => specialCardButtonAction(), 1000, {
      leading: true,
      trailing: false
    }),
    [selectedSpecialCard]
  );

  useEffect(() => {
    const interval = setInterval(() => {
      if (countDown > 0) {
        setCountDown((prevCountDown) => prevCountDown - 1);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [countDown]);
  const formattedMinutes = String(Math.floor(countDown / 60)).padStart(2, "0");
  const formattedSeconds = String(countDown % 60).padStart(2, "0");
  const formattedTime = `${formattedMinutes}:${formattedSeconds}`;
  return (
    <motion.div
      variants={divVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
    >
      {isAskerPlayer ? (
        <>
          {!_.isEmpty(currentPlayerVote) ? (
            <FlusterVote
              votePoint={currentPlayerVote?.points}
              description={"You voted!"}
            />
          ) : (
            <>
              {askerReadytoVote ? (
                <motion.div className="vote-screen">
                  <motion.p variants={fadeVariants} className="vote-txt">
                    {asker_player_vote_info}
                  </motion.p>
                  <motion.h3 variants={fadeVariants} className="heading">
                    {asker_player_vote_info2}
                  </motion.h3>
                  <FlusterVoteCard onClick={handleVotePoint} />
                  <FlusterTimeButton time={formattedTime} />
                </motion.div>
              ) : (
                <motion.div className="question-card-main">
                  <motion.h4
                    variants={fadeVariants}
                    className="question-card-heading"
                  >
                    {asker_player_info}
                  </motion.h4>
                  <div className="fluster-card-container">
                    <FlusterCard
                      card={askerAskedQuestion}
                      isSingleCard={true}
                    />
                  </div>
                </motion.div>
              )}
              <FlusterButton
                text={
                  askerReadytoVote
                    ? asker_player_vote_btn_info
                    : asker_player_btn_info
                }
                onClick={
                  askerReadytoVote ? handleVoteButtonClick : isAskerReadyVote
                }
                isQuestionScreen={true}
              />
            </>
          )}
        </>
      ) : isAnswererPlayer ? (
        <>
          <FlusterTimeButton
            time={formattedTime}
            isQuestionScreen={true}
            isQuestionScreenCardSelected={!_.isEmpty(selectedSpecialCard)}
          />
          {_.isEmpty(GetSpecialCard) ? (
            <>
              <motion.p variants={fadeVariants} className="no-spl">
                {answerer_player_info}
              </motion.p>
            </>
          ) : (
            <>
              <div className="question-card-main">
                <div
                  className={`fluster-card-container ${
                    !_.isEmpty(selectedSpecialCard) ? "flus-intro" : ""
                  }`}
                >
                  {GetSpecialCard?.map((card) => (
                    <FlusterCard
                      card={card}
                      onClick={() => handleSpecialCardClick(card)}
                      selected={selectedSpecialCard?.id === card.id}
                    />
                  ))}
                </div>
              </div>

              <FlusterButton
                text={answerer_player_btn_info}
                onClick={handleSpecialCardButton}
                isQuestionScreen={true}
              />
            </>
          )}
        </>
      ) : (
        <>
          {!_.isEmpty(currentPlayerVote) ? (
            <FlusterVote
              votePoint={currentPlayerVote?.points}
              description={"You voted!"}
            />
          ) : (
            <>
              <div className="vote-screen">
                <motion.p variants={fadeVariants} className="vote-txt">
                  {other_player_info}
                </motion.p>
                <motion.h3 variants={fadeVariants} className="heading">
                  {other_player_info2}
                </motion.h3>
                <FlusterVoteCard onClick={handleVotePoint} />
                <FlusterTimeButton time={formattedTime} />
              </div>
              <FlusterButton
                text={other_player_btn_info}
                isQuestionScreen={true}
                onClick={handleVoteButtonClick}
              />
            </>
          )}
        </>
      )}
    </motion.div>
  );
};

export default FLUSQuestion;
